import React from 'react';
import AgreementComponent from './AgreementComponent';

const TOCComponent = ({ form, currentStatus, showTitle = true, organisation = null, onSaveChanges = null, loading = false }) => {
  // Default TOC JSON structure
  const defaultTOCStructure = {
    service: {
      serviceLevelAgreement: false,
      uptimeGuarantee: false,
      supportResponse: false,
      maintenanceWindows: false,
      performanceStandards: false
    },
    compliance: {
      nhsStandards: false,
      iso27001: false,
      cyberEssentials: false,
      dataSecurityProtection: false,
      clinicalSafety: false
    },
    commercial: {
      pricingStructure: false,
      paymentTerms: false,
      contractDuration: false,
      terminationClause: false,
      liabilityLimits: false
    }
  };

  return (
    <AgreementComponent
      form={form}
      currentStatus={currentStatus}
      agreementType="toc"
      title="Terms of Contract (TOC)"
      description="Service level agreements and commercial terms"
      defaultStructure={defaultTOCStructure}
      showTitle={showTitle}
      organisation={organisation}
      onSaveChanges={onSaveChanges}
      loading={loading}
    />
  );
};

export default TOCComponent;
